import { fromJS } from 'immutable';
import * as actionTypes from '../actions/userListActionTypes';

const initialState = fromJS({
  userList: null,
  downloadRules: null,
});

const userList = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USER_LIST_REQUEST:
      return state.set('userList', action.requestPromise);
    case actionTypes.USER_LIST_SUCCESS:
      return state.set('userList', action.res);
    case actionTypes.USER_LIST_FAILURE:
      return state.set('userList', action.error);
    case actionTypes.USER_LIST_DISMISS:
      return state.set('userList', action.requestPromise);
    case actionTypes.RETRIEVE_DOWNLOAD_RULES_SUCCESS:
      return state.set('downloadRules', action.downloadRules);
    case actionTypes.RETRIEVE_DOWNLOAD_RULES_FAILURE:
      return state.set('downloadRules', null);
    default:
      return state;
  }
};

export default userList;
